import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { AsCurrencyExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/AsCurrencyExpression";

export class AsCurrencyExpressionEditor extends ExpressionRuleEditor<AsCurrencyExpression> {
    render() {
        return (
            <ExpressionPiece>
                as currency
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </BracketedDiv>
            </ExpressionPiece>
        );
    }
}
